export * from "./automatic-test.component";
export * from "./automatic-test.module";
